<template>
  <el-tooltip :content="label" placement="bottom">
    <router-link :to="computedRoute" :class="linkClass">
      <i :class="[iconClass, iconExtraClass]"></i>
      <slot></slot>
      <!-- Optional text -->
    </router-link>
  </el-tooltip>
</template>

<script>
export default {
  name: "ActionLink",
  props: {
    basePath: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    canUpdate: {
      type: Boolean,
      default: false
    },
    canRead: {
      type: Boolean,
      default: false
    },
    linkClass: {
      type: String,
      default: ""
    },
    iconExtraClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    isEditable() {
      return this.canUpdate && this.canRead;
    },
    label() {
      return this.isEditable ? "Edit" : "View";
    },
    iconClass() {
      return this.isEditable ? "flaticon-pencil" : "flaticon-visualization";
    },
    computedRoute() {
      return `${this.basePath}/${this.id}?mode=${
        this.isEditable ? "edit" : "view"
      }`;
    }
  }
};
</script>
